import { BaseResource } from './base-resource';

export class DonationInfo extends BaseResource {
  donationAmount: number;

  get isRoundUp(): boolean {
    return [1, 2, 5].indexOf(this.donationAmount) === -1;
  }
}
